/*
 * Theme Name: Caffeine
 * Theme Version: 1.4
 * Theme Direction: RTL
 * Theme Author: Nutajr
 * Nutajr Website: https://nutajr.com/
 * Theme Doc: https://help.nutajr.com/
 * Copyright: All Copyrights are reserved to Nutajr
*/

$(document).ready(() => {
	// ---------------------------------------------------------------------------
	// Money format handler
	// ---------------------------------------------------------------------------
	Shopify.money_format = "${{amount}}";
	Shopify.formatMoney = function (cents, format) {
		if (typeof cents == 'string') { cents = cents.replace('.', ''); }
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || this.money_format);

		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal = defaultOption(decimal, '.');

			if (isNaN(number) || number == null) { return 0; }

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents = parts[1] ? (decimal + parts[1]) : '';

			return dollars + cents;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	};

	class Slideshow extends HTMLElement {
		constructor() {
			super();
			this.slider = this.querySelector('.hero__slider');
			this.start = this.querySelector('.start');
			this.end = this.querySelector('.end');
			this.totalSlides = 0;
			// initSlider
			this.initSlider();

			// slickNext Method
			const nextBtn = this.querySelector('.next');
			nextBtn.addEventListener('click', (e) => e.preventDefault());
			nextBtn.addEventListener('click', this.slickNext.bind(this));

			// slickPrev Method
			const prevBtn = this.querySelector('.prev');
			prevBtn.addEventListener('click', (e) => e.preventDefault());
			prevBtn.addEventListener('click', this.slickPrev.bind(this));
		}

		initSlider() {
			$(this.slider).slick({
				rtl: true,
				slidesToShow: 1,
				arrows: true
			});
			$(this.slider).find('.slick-slide').each((index, elem) => {
				if (!$(elem).hasClass('slick-cloned')) {
					this.totalSlides++;
				}
			});
			if (this.totalSlides < 10) {
				$(this.end).text('0' + this.totalSlides);
			} else {
				$(this.end).text(this.totalSlides);
			}
			$(this.start).text('01');

			$(this.slider).on('afterChange', (event, slick, currentSlide, nextSlide) => {
				if (currentSlide < 10) {
					let newCurrentSlide = currentSlide + 1;
					$(this.start).text('0' + newCurrentSlide);
				} else {
					$(this.start).text(currentSlide);
				}
			});
		}
		slickNext() {
			this.querySelector(".slick-next").click();
			let currS = this.querySelector(".slick-current").getAttribute('data-slide');
			if (currS < 10) {
				$(this.start).text('0' + +currS);
			} else {
				$(this.start).text(currS);
			}
		}
		slickPrev() {
			this.querySelector(".slick-prev").click();
			let currS = this.querySelector(".slick-current").getAttribute('data-slide');
			if (currS < 10) {
				$(this.start).text('0' + +currS);
			} else {
				$(this.start).text(currS);
			}
		}
	}
	class Testimonials extends HTMLElement {
		constructor() {
			super();
			this.slider = this.querySelector('.slider__box');
			// initSlider
			this.initSlider();

			// slickNext Method
			const nextBtn = this.querySelector('.next__button');
			nextBtn.addEventListener('click', (e) => e.preventDefault());
			nextBtn.addEventListener('click', this.slickNext.bind(this));

			// slickPrev Method
			const prevBtn = this.querySelector('.prev__button');
			prevBtn.addEventListener('click', (e) => e.preventDefault());
			prevBtn.addEventListener('click', this.slickPrev.bind(this));
		}

		initSlider() {
			$(this.slider).slick({
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: true,
			});
		}
		slickNext() {
			this.querySelector(".slick-prev").click();
		}
		slickPrev() {
			this.querySelector(".slick-next").click();
		}
	}
	class FeaturedCollection extends HTMLElement {
		constructor() {
			super();
			this.currentLanguage = document.documentElement.lang; // Get the current language of the page
			this.slider = this.querySelector('.products__slider');
			// initSlider
			this.initSlider();

			// slickNext Method
			const nextBtn = this.querySelector('.next__arrow');
			nextBtn.addEventListener('click', (e) => e.preventDefault());
			nextBtn.addEventListener('click', this.slickNext.bind(this));

			// slickPrev Method
			const prevBtn = this.querySelector('.prev__arrow');
			prevBtn.addEventListener('click', (e) => e.preventDefault());
			prevBtn.addEventListener('click', this.slickPrev.bind(this));
		}

		initSlider() {
			$(this.slider).slick({
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				arrows: true,
				rtl: this.currentLanguage === 'ar',
				responsive: [
					{
						breakpoint: 1360,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
							infinite: false,
							dots: true
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							arrows: false,
							slidesToScroll: 1,
							dots: true
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					}
				]
			});
		}
		slickNext() {
			if (this.currentLanguage === 'ar') {
				this.querySelector(".slick-next").click();
			} else {
				this.querySelector(".slick-prev").click();
			}
		}
		slickPrev() {
			if (this.currentLanguage === 'ar') {
				this.querySelector(".slick-prev").click();
			} else {
				this.querySelector(".slick-next").click();
			}
		}
	}
	class StoreFeatures extends HTMLElement {
		constructor() {
			super();
			// this.currentLanguage = document.documentElement.lang; // Get the current language of the page
			this.slider = this.querySelector('.slider__');

			// initSlider
			this.initSlider();

			// slickNext Method
			const nextBtn = this.querySelector('.next__arrow');
			nextBtn.addEventListener('click', (e) => e.preventDefault());
			nextBtn.addEventListener('click', this.slickNext.bind(this));

			// slickPrev Method
			const prevBtn = this.querySelector('.prev__arrow');
			prevBtn.addEventListener('click', (e) => e.preventDefault());
			prevBtn.addEventListener('click', this.slickPrev.bind(this));
		}
		initSlider() {
			$(this.slider).slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			centerMode: true,
			// swipe:false,
			arrows: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						centerPadding: "20%",
					}
				}
			]
		});
			$(this.slider).find(".slick-slide .desc__>p").slideUp(200);
			$(this.slider).find(".slick-slide.slick-center .desc__>p").slideDown(200);
			$(this.slider).on('afterChange', (event, slick, currentSlide, nextSlide) => {
				setTimeout(() => {
					$(this.slider).find('.slick-slide .desc__>p').slideUp(200);
					$(this.slider).find('.slick-slide.slick-center .desc__>p').slideDown(200);
				}, 0);
			});
			$(this.slider).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				setTimeout(() => {
					$(this.slider).find('.slick-slide .desc__>p').slideUp(200);
				}, 0);
			});

		}
		slickNext() {
			this.querySelector(".slick-prev").click();
			$(this.slider).find('.slick-slide .desc__>p').slideUp(200);
		}
		slickPrev() {
			this.querySelector(".slick-next").click();
			$(this.slider).find('.slick-slide .desc__>p').slideUp(200);
		}
	}
	class ProductMedia extends HTMLElement {
		constructor() {
			super();
			this.slider = this.querySelector('.custom_flickity_product');
			// initSlider
			this.initSlider();

			// slickNext Method
			// const nextBtn = this.querySelector('.next__button');
			// nextBtn.addEventListener('click', (e) => e.preventDefault());
			// nextBtn.addEventListener('click', this.slickNext.bind(this));

			// slickPrev Method
			// const prevBtn = this.querySelector('.prev__button');
			// prevBtn.addEventListener('click', (e) => e.preventDefault());
			// prevBtn.addEventListener('click', this.slickPrev.bind(this));
		}

		// initSlider() {
		// 	$(this.slider).flickity({
		// 		rightToLeft: true,
		// 		wrapAround: true
		// 	});
		// }

// 		.flickity-prev-next-button {
//     top: 50%;
//     width: 44px;
//     height: 44px;
//     border-radius: 50%;
//     transform: translateY(-50%);
// }

// .flickity-button {
//     position: absolute;
//     background: #ffffffbf;
//     border: none;
//     color: #333;
// }
		
		initSlider() {
			$(this.slider).slick({
				rtl: document.documentElement.lang === 'ar',
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				adaptiveHeight: true,
				prevArrow: '<button type="button" class="slick-prev custom-arrow">	<svg width="24" height="45" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="#222" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
				nextArrow: '<button type="button" class="slick-next custom-arrow"><svg width="24" height="45" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" stroke="#222" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
			});
		}
		// slickNext() {
		// 	this.querySelector(".slick-prev").click();
		// }
		// slickPrev() {
		// 	this.querySelector(".slick-next").click();
		// }
	}
	customElements.define('slideshow-component', Slideshow);
	customElements.define('testimonials-component', Testimonials);
	customElements.define('featured-collection', FeaturedCollection);
	customElements.define('store-features', StoreFeatures);
	customElements.define('product-media', ProductMedia);

	//Faq section
	function faqSection(sectionId) {
		$('.elem__faq', sectionId).on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass("active");
			$(this).find('.content__', sectionId).slideToggle(300);
		});
	}

	$('[id^="shopify-section-"]').each(function () {
		const sectionId = $(this).attr('id');
		faqSection('#' + sectionId);
	});


	$('.float__picker>a').on('click', function (e) {
		e.preventDefault();
		if ($(this).hasClass("active")) {
			$(this).removeClass('active');
			$(this).closest(".float__picker").find('.dropdown__float').fadeOut(200);
		} else {
			$('.float__picker .dropdown__float').fadeOut(200);
			$('.float__picker>a').removeClass('active');
			$(this).addClass('active');
			$(this).closest(".float__picker").find('.dropdown__float').fadeIn(200);
		}
		if ($(window).width() < 767) {
			$(this).closest(".float__picker").find('.dropdown__float').css("bottom", "0px");
			$('.overlay__dropdown').fadeIn(300);
			$('body,html').css("overflow-y", "hidden")
		}
	});
	$('.overlay__dropdown').on('click', function (e) {
		e.preventDefault();
		$('.float__picker>a').removeClass('active');
		$('.float__picker .dropdown__float').fadeOut(200);
		$('.float__picker .dropdown__float').css("bottom", "-100%");
		$(this).fadeOut(300);
		$('body,html').css("overflow-y", "initial");
	});
	$('.float__picker .dropdown__float ul li a').on('click', function (e) {

		$(this).closest('.float__picker').find(">a .text").text($(this).find(".text").text());
		if ($(this).find(".flag").length) {
			$(this).closest('.float__picker').find(">a .flag img").attr("src", $(this).find(".flag>img").attr("src"));
		}
		$(this).closest(".dropdown__float").fadeOut(300);
		$(this).closest('.float__picker').find(">a").removeClass('active');
		if ($(window).width() < 767) {
			$('.float__picker .dropdown__float').css("bottom", "-100%");
			$('body,html').css("overflow-y", "initial");
			$('.overlay__dropdown').fadeOut(300);
		}
	});
	$(document).click(function (event) {
		var $target = $(event.target);
		if (!$target.closest('.float__picker').length) {
			$('.float__picker>a').removeClass('active');
			$('.float__picker .dropdown__float').fadeOut(200);
		}
	});

	$('.orders__switcher ul li a').on('click', function (e) {
		e.preventDefault();
		if (!$(this).hasClass("active")) {
			$(this).closest('ul').find('.active').removeClass('active');
			$(this).addClass('active');

			$('.orders__table').css("display", "none");
			$('.orders__table.' + $(this).attr("data-tab")).fadeIn(300);
		}
	});



	$('.profile__details .login').on('click', function (e) {
		e.preventDefault();
		$('.modal__box.login').closest('.modal__wrapper').fadeIn(300);
		$('body,html').css("overflow-y", "hidden");
	});

	$('.modal__wrapper .modal__box.login .close__popup').on("click", function (e) {
		e.preventDefault();
		$(this).closest(".modal__wrapper").fadeOut(300);
		$('body,html').css("overflow-y", "initial");
	});

	$('.modal__wrapper .gallery__modal .close__popup').on("click", function (e) {
		e.preventDefault();
		$(this).closest(".modal__wrapper").fadeOut(300);
		$('body,html').css("overflow-y", "initial");
		$('.el__media.current').removeClass("current");
	});

	$('.medias__feedback .el__media').on('click', function (e) {
		$('.medias__feedback .el__media').removeClass('current');
		$(this).addClass("current");
		$('.gallery__modal').closest(".modal__wrapper").fadeIn(300);
		$('body,html').css("overflow-y", "hidden");
		$('.gallery__modal>img').attr('src', $('.el__media.current').attr("data-gallery"));
	});
	$('.gallery__modal .prev__gallery').on('click', function (e) {
		e.preventDefault();
		if ($('.el__media.current').prev().length != 0) {
			$(".el__media.current").removeClass('current').prev().addClass("current");
			$('.gallery__modal>img').css("display", "none");
			$('.gallery__modal>img').attr('src', $('.el__media.current').attr("data-gallery"));
			$('.gallery__modal>img').fadeIn(300);
		} else {
			$('.el__media.current').removeClass("current").closest(".medias__feedback").find(".el__media:last-child").addClass("current");
			$('.gallery__modal>img').css("display", "none");
			$('.gallery__modal>img').attr('src', $('.el__media.current').attr("data-gallery"));
			$('.gallery__modal>img').fadeIn(300);
		}
	});
	$('.gallery__modal .next__gallery').on('click', function (e) {
		e.preventDefault();
		if ($('.el__media.current').next().length != 0) {
			$(".el__media.current").removeClass('current').next().addClass("current");
			$('.gallery__modal>img').css("display", "none");
			$('.gallery__modal>img').attr('src', $('.el__media.current').attr("data-gallery"));
			$('.gallery__modal>img').fadeIn(300);
		} else {
			$('.el__media.current').removeClass("current").closest(".medias__feedback").find(".el__media:nth-child(1)").addClass("current");
			$('.gallery__modal>img').css("display", "none");
			$('.gallery__modal>img').attr('src', $('.el__media.current').attr("data-gallery"));
			$('.gallery__modal>img').fadeIn(300);
		}
	});


	$('.modal__box.share .close__popup').on("click", function (e) {
		e.preventDefault();
		$(this).closest('.modal__wrapper').fadeOut(300);
		$('body,html').css("overflow-y", 'initial');
	});

	$('.share__btn').on("click", function (e) {
		e.preventDefault();
		$('.modal__box.share').closest(".modal__wrapper").fadeIn(300);
		$('body,html').css("overflow-y", "hidden");
	});

	// if ($('.product__main').length) {
	// 	if ($(window).width() < 991) {
	// 		$('.product__main .gallery__slider .slide__inner').slick({
	// 			slidesToShow: 1,
	// 			rtl: true,
	// 			arrows: true,
	// 			infinite: true
	// 		})
	// 	}
	// 	$(window).on('resize', function () {
	// 		if ($(window).width() < 991 && !$('.slide__inner').hasClass('slick-initialized')) {
	// 			$('.product__main .gallery__slider .slide__inner').slick({
	// 				slidesToShow: 1,
	// 				rtl: true,
	// 				arrows: true,
	// 				infinite: true
	// 			})
	// 		}
	// 	});

	// 	$('.product__main .gallery__slider .left__arr').on('click', function (e) {
	// 		e.preventDefault();
	// 		$('.product__main .gallery__slider .slick-next').click();
	// 	});
	// 	$('.product__main .gallery__slider .right__arr').on('click', function (e) {
	// 		e.preventDefault();
	// 		$('.product__main .gallery__slider .slick-prev').click();
	// 	});
	// }


	$('.image__loader>a').on('click', function (e) {
		e.preventDefault();
		$(this).closest('.image__loader').find('input').click();
	});

	$('.add__feedback--button').on('click', function (e) {
		e.preventDefault();
		$(".add__feedback").fadeIn(300);
		$(this).addClass('active');
	});

	$('.stars__picker ul li a').on('click', function (e) {
		e.preventDefault();
		if ($(this).closest("li").next("li").find("a.active").length == 0 && $(this).hasClass('active')) {
			$(this).closest("ul").find(".active").removeClass('active');
		} else {
			$(this).closest("ul").find(".active").removeClass('active');
			let currIndex = $(this).attr("data-index");
			$(this).closest('ul').find("li").each(function (index, elem) {
				if ($(elem).find("a").attr("data-index") <= currIndex) {
					$(elem).find("a").addClass("active");
				}
			});
		}
	});


	$('.elem__feedback .feedback__desc>p a').on('click', function (e) {
		e.preventDefault();
		$(this).closest("p").toggleClass("opened");
		if ($(this).closest('p').hasClass("opened")) {
			$(this).text("show less");
		} else {
			$(this).text("show more");
		}
	});


	$(".swipe__me").on("swipedown", (e) => {
		$('.filter').css("bottom", "-100%");
		$('body,html').css('overflow-y', "initial");
	});
	$('.filter__bar .group__input>a').on("click", function (e) {
		e.preventDefault();
		$('.filter').css("bottom", "0px");
		$("body,html").css("overflow-y", "hidden");
	});
	
	$('body').on('click', '.qv-el__small__image', function (e) {
		e.preventDefault();
		let imgSrc = $(this).data("image");
		$('.qv-product-main__image img').attr("src", imgSrc);
	});

	$('body').on('click', '.product__popup', async function (e) {
		e.preventDefault();
		var variantData;
		let moneyFormat = $(this).data("money-format");
		$(this).children('.loading-overlay__spinner').show();
		$(this).children('.quick-btn_text').hide();
		var product_handle = $(this).data('handle');
		$('variant-selector.qv_variant_selector').attr('data-url', '/products/' + product_handle);
		try {
			var product = await new Promise((resolve, reject) => {
				jQuery.getJSON(Shopify.routes.root + 'products/' + product_handle + '.js', function (product) {
					resolve(product);
				}).fail(function (jqXHR, textStatus, error) {
					reject(new Error(error));
				});
			});
			var title = product.title;
			var price = 0;
			var original_price = 0;
			var desc = product.description;
			var images = product.images;
			variantData = product.variants;
			var options = product.options;
			var url = Shopify.routes.root + 'products/' + product_handle;
			$("#product-form").attr('product-url', product.url);
			$("#product-form").attr('id', `product-form-${product.id}`);
			// $("#product-form").attr('id', product.url);
			$(".add-to-cart-item").attr("data-product-form-id", `product-form-${product.id}`);
			$('.qv-product-title').text(title);
			if (desc == "") {
				$(".qv-desc-main").hide();
			} else {
				$(".qv-desc-main").show();
				$('.qv-product-description').html(desc);
			}
			$('.view-product').attr('href', url);
			var imageCount = $(images).length;
			$(images).each(function (i, image) {
				if (image == "" || image == null) {
					$('.qv-product-main__image img').attr("src", "");
					$('.qv-product-small__gallery').html('');
				} else {
					if (i == 0) {
						var image_embed = image.replace('.jpg', '_480x.jpg').replace('.png', '_480x.png');
						$('.qv-product-main__image img').attr("src", image_embed);
						$('.qv-product-small__gallery').html('');
						$('.qv-product-small__gallery').removeClass("qv-small__gallery");
					}
					var image_main = image.replace('.jpg', '_480x.jpg').replace('.png', '_480x.png');
					var image_embed = image.replace('.jpg', '_110x.jpg').replace('.png', '_110x.png');
					var image_html = `<div class="el__small qv-el__small" data-image="${image_main}">
                                    <img src="${image_embed}" alt="el" class="qv-el__small__image" loading="lazy" data-image="${image_main}">
                                </div>`;
					$('.qv-product-small__gallery').append(image_html);
					if (i > 4) {
						$('.qv-product-small__gallery').addClass("qv-small__gallery");
					}
				}
			});
			$('.qv_variant_selector').html('');
			$(options).each(function (i, option) {
				var opt = option.name.replace(' ', '_');
				if (opt != "Title") {
					var selectClass = '.option.' + opt.toLowerCase();
					$('.qv_variant_selector').append('<p class="option">' + opt + '</p><ul class="option_ul_tag qv_option_ul_tag option-' + i + ' option ' + opt.toLowerCase() + '"></ul>');
					$(option.values).each(function (i, value) {
						var active = "";
						if (i == 0) {
							active = "active";
						}
						$(selectClass).append('<li class="qv_option_li_tag"><a href="javascript:void(0);" value="' + value + '" class="qv_option_a_tag ' + active + '">' + value + '</a></li>');
					});
				}
			});


			$(".qv-product-form").find('input[name="id"]').val(variantData[0].id);
			if (variantData[0].compare_at_price === null) {
				$('.product-compare-at-price').html("");
			} else if (variantData[0].compare_at_price != "" || variantData[0].compare_at_price != null) {
				$('.product-compare-at-price').html(Shopify.formatMoney(variantData[0].compare_at_price, moneyFormat));
			} else {
				$('.product-compare-at-price').html("");
			}
			$('.product-orignal-price').html(Shopify.formatMoney(variantData[0].price, moneyFormat));

			$('li.qv_option_li_tag').click();
			$(function () {
				var options;
				var currentVariant;

				$('li.qv_option_li_tag').on('click', function (event) {
					event.preventDefault();
					let previousParent = $(this).parent('.qv_option_ul_tag');
					let previousActive = $(previousParent).find('.qv_option_li_tag > .active');
					if (previousActive.length) {
						previousActive.removeClass('active');
					}
					$(event.target).addClass('active');
					onVariantChange();
				});

				function onVariantChange() {
					getSelectedOptions();
					getSelectedVariant();
					if (currentVariant) {
						updateFormID();
						updatePrice();
						updateImage();
					}
				}

				function getSelectedOptions() {
					options = $.map($('ul.qv_option_ul_tag'), function (ul) {
						let activeOption = $(ul).find('a.active');
						return activeOption.length ? activeOption.attr('value') : null;
					});
				}

				function getSelectedVariant() {
					currentVariant = $.grep(variantData, function (variant) {
						return variant.options.every((option, index) => options[index] === option);
					})[0];
				}

				function updateFormID() {
					$(".qv-product-form").find('input[name="id"]').val(currentVariant.id);
				}

				function updatePrice() {
					if (currentVariant.compare_at_price === null) {
						$('.product-compare-at-price').html("");
					} else if (currentVariant.compare_at_price != "" || currentVariant.compare_at_price != null) {
						$('.product-compare-at-price').html(Shopify.formatMoney(currentVariant.compare_at_price, moneyFormat));
					} else {
						$('.product-compare-at-price').html("");
					}
					$('.product-orignal-price').html(Shopify.formatMoney(currentVariant.price, moneyFormat));
				}

				function updateImage() {
					if (currentVariant.featured_image != null) {
						var image_embed = currentVariant.featured_image.src.replace('.jpg', '_480x.jpg').replace('.png', '_480x.png');
						$('.qv-product-main__image img').attr("src", image_embed);
					}
				}

			});


		} catch (error) {
			console.error("Error fetching product:", error);
			return; // Stop executing if there was an error
		}

		$('body,html').css("overflow-y", "hidden");
		$('.small__gallery').imagesLoaded(function () {
			$('.quick__shopping .small__gallery .el__small').each(function (index, elem) {
				$(elem).css("height", $(elem).css('width'));
			});
		});
		$('.quick__shopping').closest(".modal__wrapper").fadeIn(300);
		$('.loading-overlay__spinner').hide();
		$('.quick-btn_text').show();
	});
	// Founded
	function getSectionsToRender() {
		const sections = [
			{
				id: "header",
				section: document.getElementById("header").dataset.id,
				selector: ".cart__wrapper",
			},
		];
		if (window.location.pathname == window.Shopify.routes.root + "cart")
			sections.push({
				id: "template-cart",
				section: document.getElementById("template-cart").dataset.id,
				selector: ".template-cart",
			});
		return sections;
	}
	let getSectionInnerHTML = (html, selector) => {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	};

	function debounce(callback, wait) {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				callback.apply(this, args);
			}, wait);
		};
	}

	const updateQuantity = async (
		section_id = 0,
		line,
		quantity,
		initQuantity
	) => {
		try {
			const config = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify({
					line: line,
					quantity: quantity,
					sections: getSectionsToRender().map((section) => section.section),
					sections_url: window.location.pathname,
				}),
			};
			// enableLoading(section_id, line);
			const response = await fetch(
				window.Shopify.routes.root + "cart/change",
				config
			);
			const state = await response.text();
			const parsedState = JSON.parse(state);
			if (parsedState.errors) {
				$(".cart-err-msg").text(parsedState.errors);
				$(".quantity__input").val($(".quantity__input").attr("value"));
				return;
			}
			getSectionsToRender().forEach((section) => {
				const elementToReplace =
					document.getElementById(section.id).querySelector(section.selector) ||
					document.getElementById(section.id);
				elementToReplace.innerHTML = getSectionInnerHTML(
					parsedState.sections[section.section],
					section.selector
				);
			});
		} catch (err) {
			console.log(err.message);
		}
	};

	$(document).on("click", ".add-to-cart-item", async function (e) {
		e.preventDefault();
		let form_id = $(this).data("product-form-id");
		console.log(form_id);
		$(this).children('.loading-overlay__spinner').show();
		$(this).children('.quick-btn_text').hide();
		let addToCartItem = $(this);
		let page_lang = $("html").attr("lang");
		let success_msg =
			page_lang == "ar"
				? "تم إضافة المنتج إلى عربة التسوق بنجاح"
				: "Product has been added to Cart Successfully";
		let error_msg =
			page_lang == "ar"
				? "لا يمكن إضافة منتجات إضافية أو قد يكون المنتج تم نفاذ كميته"
				: "Additional products cannot be added or the product may be out of stock";
		let product_url = $(`#${form_id}`).attr("product-url");
		let variant_id = $(`#${form_id}`).find('input[name="id"]').val();
		let quantity = $(`#${form_id}`).find('input[name="quantity"]').val();
		console.log(product_url, variant_id, quantity);
		jQuery.getJSON(product_url + ".js", function (product) {
			jQuery
				.post(window.Shopify.routes.root + "cart/add.js", {
					id: variant_id,
					quantity: quantity,
					sections: getSectionsToRender().map((section) => section.section),
					sections_url: window.location.pathname,
				})
				.done(function (state) {
					const parsedState = JSON.parse(state);
					getSectionsToRender().forEach((section) => {
						const elementToReplace =
							document
								.getElementById(section.id)
								.querySelector(section.selector) ||
							document.getElementById(section.id);
						elementToReplace.innerHTML = getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector
						);
					});
					addToCartItem.children('.loading-overlay__spinner').hide();
					addToCartItem.children('.quick-btn_text').show();
					$(".quantity-message")
						.show()
						.stop()
						.removeClass("error-message")
						.addClass("success-message")
						.stop()
						.text(success_msg);
					setTimeout(() => {
						$(".quantity-message")
							.hide()
					}, 3000);
				})
				.fail(function (xhr, textStatus, errorThrown) {
					addToCartItem.children('.loading-overlay__spinner').hide();
					addToCartItem.children('.quick-btn_text').show();
					$(".quantity-message")
						.show()
						.stop()
						.removeClass("success-message")
						.addClass("error-message")
						.stop()
						.text(error_msg);
					setTimeout(() => {
						$(".quantity-message")
							.hide()
					}, 3000);
				});
		});
	});

	$(document).on("click", ".quantity.picker .plus", function (e) {
		e.preventDefault();
		let line = $(this).data("index");
		let quantity = +$(this).next().val() + 1;
		$(this).next().val(+$(this).next().val() + 1);
		updateQuantity((section_id = 0), line, quantity);
	});
	$(document).on(
		"keyup",
		".quantity__input",
		debounce(function (el) {
			let line = $(el.target).data("index");
			let quantity = $(el.target).val();
			updateQuantity((section_id = 0), line, quantity);
		}, 500)
	);
	$(document).on("click", ".quantity.picker .minus", function (e) {
		e.preventDefault();
		if ($(this).prev().val() > 1) {
			let line = $(this).data("index");
			let quantity = +$(this).prev().val() - 1;
			$(this).prev().val(+$(this).prev().val() - 1);
			updateQuantity((section_id = 0), line, quantity);
		}
	});

	$(document).on("click", ".remove-cart-item", function () {
		let section_id = $(this).data("section-id");
		updateQuantity(section_id, $(this).data("index"), 0);
	});




	$('.quick__shopping .close__popup').on("click", function (e) {
		e.preventDefault();
		$('.loading-overlay__spinner').hide();
		$('.quick__shopping').closest('.modal__wrapper').fadeOut(300);
		$('body,html').css("overflow-y", "initial");
	});
	$(document).click(function (e) {
		if ($(".quick__shopping").is(":visible") && !$(".quick__shopping").is(e.target) && !$(".quick__shopping").has(e.target).length) {
			$('.loading-overlay__spinner').hide();
			$('.quick__shopping').closest('.modal__wrapper').fadeOut(300);
			$('body,html').css("overflow-y", "initial");
		}
		if ($(".quick__login").is(":visible") && !$(".quick__login").is(e.target) && !$(".quick__login").has(e.target).length) {
			$('.quick__login').closest(".modal__wrapper").fadeOut(300);
			$('body,html').css("overflow-y", "initial");
		}
	});

	if ($('.quick__shopping').length) {
		$('.product__gallery').imagesLoaded(function () {
			$('.product__gallery .main__image').css("height", $('.product__gallery .main__image').css("width"));
		})
		$('.small__gallery').imagesLoaded(function () {
			$(' .small__gallery .el__small').each(function (index, elem) {
				$(elem).css("height", $(elem).css('width'));
			});
		});

		$(window).on("resize", function () {
			$('.product__gallery').imagesLoaded(function () {
				$('.product__gallery .main__image').css("height", $('.product__gallery .main__image').css("width"));
			})
			$('.small__gallery').imagesLoaded(function () {
				$('.small__gallery .el__small').each(function (index, elem) {
					$(elem).css("height", $(elem).css('width'));
				});
			});
		});

		if ($('.small__gallery').length) {
			$('.small__gallery .el__small').each(function (index, elem) {
				$(elem).attr("data-index", index + 1);
			});
		}

		$('.small__gallery .el__small').on('click', function () {
			$(".product__gallery .main__image img").attr('src', $(this).attr('data-image'));
			let currentWidth = +$('.small__gallery .el__small:nth-child(1)').width() + +$('.small__gallery .el__small:nth-child(1)').css("margin-left").slice(0, -2);
			let currEl = +$(this).attr("data-index");
			/*
			$('.small__gallery').animate({ 
				scrollLeft:   "-" +  (currentWidth*currEl - currentWidth + "px")
			}, 500
			); */
		});
	}

	$('.size__picker ul li a').on('click', function (e) {
		e.preventDefault();
		if (!$(this).hasClass('active')) {
			$(this).closest('ul').find('.active').removeClass('active');
			$(this).addClass("active");
		}
	});



	$('.color__picker ul li a').on('click', function (e) {
		e.preventDefault();
		if (!$(this).hasClass('active')) {
			$(this).closest('ul').find('.active').removeClass('active');
			$(this).addClass("active");
		}
	});


	$('.quantity .quantity__field .plus').on("click", function (e) {
		e.preventDefault();
		$(this).closest('.quantity__field').find("input").val(+$(this).closest('.quantity__field').find("input").val() + 1);
	});
	$('.quantity .quantity__field .minus').on("click", function (e) {
		e.preventDefault();
		if ($(this).closest(".quantity__field").find('input').val() > 1) {
			$(this).closest('.quantity__field').find("input").val(+$(this).closest('.quantity__field').find("input").val() - 1);
		}
	});


	$('.modal__notification .button__wrapper>a').on("click", function (e) {
		e.preventDefault();
		$(this).closest('.modal__wrapper').fadeOut(300);
		$('body,html').css("overflow-y", "initial");
	});


	$('.notification').on('click', function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		if ($(this).hasClass("active")) {
			$(this).closest('.notification__wrapper').find('.notification__box').fadeIn(300);
		} else {
			$(this).closest('.notification__wrapper').find('.notification__box').fadeOut(300);
		}
	});

	$(document).on("click", ".cart__wrapper>.cart", function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		if ($(this).hasClass("active")) {
			$(this).closest('.cart__wrapper').find('.cart__box').fadeIn(300);
		} else {
			$(this).closest('.cart__wrapper').find('.cart__box').fadeOut(300);
		}
	});

	$('.profile__details .profile__button').on('click', function (e) {
		$(this).toggleClass('active');
		if ($(this).hasClass('active')) {
			$(this).closest('.profile__details').find(".dropdown__profile").fadeIn(300);
		} else {
			$(this).closest('.profile__details').find(".dropdown__profile").fadeOut(300);
		}
	});

	$(document).click(function (event) {
		var $target = $(event.target);
		if (!$target.closest('.profile__details').length) {
			$('.profile__details .dropdown__profile').fadeOut(300);
			$('.profile__button').removeClass('active');
		}
		if (!$target.closest('.notification__wrapper').length) {
			$('.notification__wrapper .notification__box').fadeOut(300);
			$('.notification__wrapper>.notification').removeClass('active');
		}
		if (!$target.closest('.cart__wrapper').length) {
			$('.cart__wrapper .cart__box').fadeOut(300);
			$('.cart__wrapper>a').removeClass('active');
		}
	});

	$('.mobile__menu .dropdown__box>a').on("click", function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).closest('.dropdown__box').find("ul").slideToggle(300);
	});

	$('.mobile__menu .profile>a').on("click", function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).closest('.profile').find(".profile__dropdown").slideToggle(300);
	});


	$('.menu__button>a').on("click", function (e) {
		e.preventDefault();
		$('.overlay').fadeIn(300);
		$('body,html').css("overflow-y", "hidden");
		$('.mobile__menu').css("right", "0px");
	});

	$('.overlay').on('click', function (e) {
		e.preventDefault();
		$('.overlay').fadeOut(300);
		$('body,html').css("overflow-y", "initial");
		$('.mobile__menu').css("right", "-290px");
	});

	if ($('.product__main').length) {
		if ($(window).width() < 991) {
			$('.slide__inner_ar').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				rtl: true,
				arrows: true,
				asNavFor: '.slide__inner-slider-nav'
			});
			$('.slide__inner-slider-nav').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				asNavFor: '.slide__inner_ar',
				dots: false,
				rtl: true,
				centerMode: true,
				focusOnSelect: true
			});
		}

		// $('.product__main .gallery__slider .left__arr').on('click', function (e) {
		// 	e.preventDefault();
		// 	$('.product__main .gallery__slider .slick-next').click();
		// });
		// $('.product__main .gallery__slider .right__arr').on('click', function (e) {
		// 	e.preventDefault();
		// 	$('.product__main .gallery__slider .slick-prev').click();
		// });
	}
}); 





